module.exports = __webpack_public_path__ + "img/header_m.bf11fde6.png";